import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { NewsletterUpdateInterface } from 'modules/newsletters/single/types/newsletter-update-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { NewsletterViewApiType } from '../types/newsletter-view-interface'

export const useUpdateNewsletter = <TResponse extends NewsletterViewApiType>(id: NewsletterId) => {
  const { fetcher } = useFetch<RequestMethodsEnum.put, TResponse>({
    method: RequestMethodsEnum.put,
  })

  return {
    fetcherUpdateNewsletter: (payload: NewsletterUpdateInterface) =>
      fetcher(`${NEWSLETTERS_API}/${id}`, payload),
  }
}
